import React from "react"
import { Location } from '@reach/router';
import FreestarAdSlot from '@freestar/pubfig-adslot-react-component'

class Ad extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { 
      error: null, 
      errorInfo: null, 
    };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo
    })
  }

  render() {
    const freestarPublisher = 'yaytext-com'
    const { location, ezoic_placeholder_id, adsense_slot, adsense_format, adsense_layout, ad_class, freestarPlacementName } = this.props;
    let style = { display: 'block' };
    if (this.props.ad_style) {
      style = {...style,...this.props.ad_style};
    }
    let key = location.pathname;
    let name = `${adsense_slot||''}_${ezoic_placeholder_id||''}_${freestarPlacementName||''}`;

    if (this.state.error || this.state.errorInfo) {
      return (null);
    }

    return <>
      {
        freestarPlacementName && <FreestarAdSlot
          publisher={freestarPublisher}
          placementName={freestarPlacementName}
          // onNewAdSlotsHook={(placementName) => console.log('creating ad', placementName)}
          // onDeleteAdSlotsHook={(placementName) => console.log('destroying ad', placementName)}
          // onAdRefreshHook={(placementName) => console.log('refreshing ad', placementName)}
        />
      }
      {
        false && adsense_slot &&
        <ins className={`adsbygoogle ${ad_class?ad_class:''}`}
             key={`${key}_${name}_ad`}
             style={style}
             data-ad-client="ca-pub-6111093976480615"
             data-ad-slot={adsense_slot}
             data-ad-format={adsense_format}
             data-ad-layout={adsense_layout ? adsense_layout : undefined}
             data-full-width-responsive={adsense_format === "auto" ? "true" : undefined}
             data-adtest={process.env.NODE_ENV === "development" ? "on" : undefined}></ins>
      }
    </>
  }
}

const Component = props => (
  <Location>
    {locationProps => <Ad {...locationProps} {...props} />}
  </Location>
);

export default Component;